import { type ComponentProps, forwardRef } from 'react'
import Map, { MapRef } from 'react-map-gl'

interface MapRootProps extends ComponentProps<typeof Map> {}

export const MapRoot = forwardRef<MapRef, MapRootProps>((props, ref) => {
  return (
    <Map
      ref={ref}
      mapboxAccessToken={
        import.meta.env?.VITE_MAPBOX_TOKEN ?? window.env?.MAPBOX_TOKEN
      }
      {...props}
    />
  )
})

MapRoot.displayName = 'MapRoot'
